export default __webpack_public_path__ + "locales/ar-SA/DeleteThirdPartyDialog.json?hash=ea3102b3e81d2c48a6a186f44c57ca2a";